import { isNullish } from '@/utils/helper'
import { OfferStage, OfferStatus, RoleInOffer } from '..'
import { getStage } from '../../helpers'
import { ContributorGroupType } from '@/features/contributorGroups/constants'

export const offerSourcingGroupPolicyType = {
  SOURCING_PROCUREMENT_OFFICER: 'SOURCING_PROCUREMENT_OFFICER',
  SOURCING_DEADLINE: 'SOURCING_DEADLINE',
  SOURCING_COST_BUDGET: 'SOURCING_COST_BUDGET',
  SOURCING_ADD_REMOVE_COST_BUDGET: 'SOURCING_ADD_REMOVE_COST_BUDGET',

  SOURCING_PM040_TECHNICAL: 'SOURCING_PM040_TECHNICAL',
  SOURCING_PM040_PROCUREMENT: 'SOURCING_PM040_PROCUREMENT',
  SOURCING_PM100_TECHNICAL: 'SOURCING_PM100_TECHNICAL',
  SOURCING_PR: 'SOURCING_PR',
}

const allTechnicalEditingRole = [
  RoleInOffer.INITIATOR,
  RoleInOffer.CREATOR,
  RoleInOffer.DEPT_USER,
  RoleInOffer.TEAM_ASSISTANT,
]

export const offerSourcingGroupPolicies = {
  [offerSourcingGroupPolicyType.SOURCING_PROCUREMENT_OFFICER]: {
    view: true,
    edit: ({ role, offer, isFreeze, userGroup }) =>
      !isFreeze &&
      (allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER) &&
      isNullish(offer?.sourcing?.procurementOfficer),
  },
  [offerSourcingGroupPolicyType.SOURCING_DEADLINE]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, userGroup }) => {
      if (isFreeze) {
        return false
      }

      if (role === RoleInOffer.PROCUREMENT_OFFICER) {
        return true
      }

      if (offerStatus === OfferStatus.BOOKING_COMPLETED) {
        return [RoleInOffer.BOOKING_MANAGER, RoleInOffer.ENGINEER].includes(role)
      } else {
        return allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER
      }
    },
  },
  [offerSourcingGroupPolicyType.SOURCING_COST_BUDGET]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, userGroup }) => {
      return ![RoleInOffer.CONTRIBUTOR_LEGAL, RoleInOffer.CONTRIBUTOR_QS].includes(role)
    },
  },
  [offerSourcingGroupPolicyType.SOURCING_ADD_REMOVE_COST_BUDGET]: {
    view: true,
    edit: ({ role, isFreeze, offerStatus, userGroup }) => {
      return ![RoleInOffer.CONTRIBUTOR_LEGAL, RoleInOffer.CONTRIBUTOR_QS].includes(role)
    },
  },
  [offerSourcingGroupPolicyType.SOURCING_PM040_TECHNICAL]: {
    view: true,
    edit: ({ role, offerStatus, isFreeze, userGroup }) => {
      if (isFreeze || getStage(offerStatus) !== OfferStage.QUOTATION) {
        return false
      }
      return ![RoleInOffer.CONTRIBUTOR_LEGAL, RoleInOffer.CONTRIBUTOR_QS].includes(role)
    },
  },
  [offerSourcingGroupPolicyType.SOURCING_PM040_PROCUREMENT]: {
    view: true,
    edit: ({ role, offerStatus, isFreeze }) =>
      !isFreeze && role === RoleInOffer.PROCUREMENT_OFFICER && getStage(offerStatus) === OfferStage.QUOTATION,
  },

  [offerSourcingGroupPolicyType.SOURCING_PM100_TECHNICAL]: {
    view: true,
    edit: ({ role, offerStatus, isFreeze, userGroup }) => {
      if (isFreeze || getStage(offerStatus) !== OfferStage.BOOKING) {
        return false
      }
      return ![RoleInOffer.CONTRIBUTOR_LEGAL, RoleInOffer.CONTRIBUTOR_QS].includes(role)
    },
  },
  [offerSourcingGroupPolicyType.SOURCING_PR]: {
    view: true,
    edit: ({ role, offerStatus, isFreeze, userGroup, allRoles }) => {
      if (getStage(offerStatus) !== OfferStage.BOOKING) {
        return false
      }

      return ![RoleInOffer.CONTRIBUTOR_LEGAL, RoleInOffer.CONTRIBUTOR_QS].includes(role)
    },
  },
}
